import parseParamsObject from './parse-params-object.js'
import appIsReady from './app-is-ready.js'
import loginRequired from './login-required.js'
import defaultSubroute from './default-subroute.js'
import canUseFrontdesk from './can-use-frontdesk.js'
import isBusinessCorrect from './is-business-correct.js'
import checkAccessLevel from './check-access-level.js'
import checkAccessLevelPermission from './check-access-level-permission.js'
import trackPage from './track-page.js'
import restrictedBySubscription from './restricted-by-subscription.js'
import setRoutes from './set-routes.js'
import versionCheck from './version-check.js'
import reloadPage from './reload-page.js'

import { useLogger } from '@booksy-com/vue-tools'
const logger = useLogger('router.guards.index')

export function registerGuards (router) {
  logger.debug('registering router guards')

  // HACK-VUE3
  router.beforeEach(parseParamsObject)

  router.beforeEach(appIsReady)

  router.beforeEach(defaultSubroute)

  router.beforeEach(loginRequired)

  router.beforeEach(isBusinessCorrect)

  router.beforeEach(checkAccessLevelPermission)

  router.beforeEach(checkAccessLevel)

  router.beforeEach(canUseFrontdesk)

  // access to router is required to send analytics
  router.beforeEach(trackPage.bind(router))

  router.beforeEach(restrictedBySubscription)

  router.beforeEach(setRoutes)

  router.beforeEach(reloadPage)

  router.afterEach(versionCheck)
}
